<template>
    <div class="example">
        {{configuration.component_data}}
        <slot />
    </div>
</template>

<script>
    export default {
        name: 'Example',
        props: {
            configuration: Object
        }
    }
</script>

<style lang="less">
    @import "~@/assets/less/variables";

    .example
    {

    }
</style>
